import {
  BarChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

import { X_Y_AXIS_STYLE } from './constants';
import { getBarElements, getNoDataMessage } from './Elements';
import CustomTooltip from '../../Components/CustomToolTip';
import { SLICE_STATUS } from 'utils/constants';
import { RequestsBy } from 'utils/customTypes';
import ErrorScreen from '../../Components/ErrorScreen';
import RequestsBySkeletonLoading from './RequestsBySkeletonLoader';

const BusinessUnitChart = ({
  status,
  state,
}: {
  status: string;
  state: RequestsBy;
}) => {
  return status === SLICE_STATUS.LOADING ? (
    <RequestsBySkeletonLoading />
  ) : status === SLICE_STATUS.FAILED ? (
    <ErrorScreen />
  ) : state.values.length === 0 ? (
    getNoDataMessage()
  ) : (
    <ResponsiveContainer width='90%' height='90%'>
      <BarChart
        data={state.values}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        barSize={30}
        maxBarSize={20}
      >
        <CartesianGrid horizontal={false} vertical={false} />
        <XAxis
          tickLine={false}
          dataKey='monthShortLabel'
          style={X_Y_AXIS_STYLE}
          padding={{ left: 30, right: 30 }}
        />
        <YAxis tickLine={false} style={X_Y_AXIS_STYLE} />
        <Tooltip
          content={<CustomTooltip chartType='Bar' />}
          wrapperStyle={{
            zIndex: 20,
            maxHeight: '25rem',
            overflowY: 'auto',
            pointerEvents: 'auto',
          }}
        />
        {getBarElements(state.seriesNames)}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BusinessUnitChart;
